import { render } from "./BrTerms.vue?vue&type=template&id=14f14884&scoped=true"
import script from "./BrTerms.vue?vue&type=script&lang=js"
export * from "./BrTerms.vue?vue&type=script&lang=js"

import "./BrTerms.vue?vue&type=style&index=0&id=14f14884&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f14884"]])

export default __exports__